<template>
  <div>
    <my-loader v-if="loading"></my-loader>
    <modal-dialog v-model:show="dialogVisible">
      <ExecutorFormSearch v-if="modalSwitcher" @setExecutor="addExecutor" />
      <CustomerFormSearch v-else @setCustomer="addCustomer" />
    </modal-dialog>
    <div v-if="trip" class="cards">
      <div class="header-content">
        <div class="nav-top">
          
          <font-awesome-icon
          title="Обновить рейс"
          class="icon"
           icon="fa-solid fa-rotate"
           @click="refresh('Trip')" />
          <button v-if="canKonturExport" class="kontur-button" :disabled="konturLoading" @click="downloadKontur">
            {{ konturLoading ? 'Проверка Kontur...' : 'Kontur XML' }}
          </button>
        </div>
        <div>
          <h3 class="trip-number">Рейс №
          <a v-if="trip.tms_id" class="tms-link" :href="`${TMS_WEB_URL}/grid/shippings/${trip.tms_id}`" target="_blank" rel="noopener">{{trip.trip_id}}</a>
          <template v-else>{{trip.trip_id}}</template>
          <span v-if="trip.work_status" >- {{trip.work_status.name}}</span>
          <span class="trip-manager">· Менеджер: {{ trip.responsible ? trip.responsible.name : 'не назначен' }}</span>
          </h3>
        </div>
        <div style="width:78px;"></div>
      </div>

      <div class="">
        <div >
          <TripManagerMenu v-if="trip.work_status" :trip="trip" @updateTrip="updateTrip" @forceInput="forceRender" />
        </div>
        <TripInput :trip="trip" @updateTrip="updateTrip" :key="inputKey" @forceInput="forceRender"/>
        <div class="executors-info">
          <ExecutorTripInfo
          v-if="useNewExecutorInfo && (trip.executor || trip.random_executor)"
          :key="'new-executor-info-'+trip.id"
          :trip="trip"
          :executor="trip.executor"
          :random-executor="trip.random_executor"
          @assignExecutor="showModal('executor')"
          @updateExecutor="updateExecutor"
          @sendOrder="sendOrder"
          @sendTMS="sendTMS"/>
          <ExecutorTripInfoLegacy
          v-else-if="trip.executor"
          :key="'legacy-executor-info-'+trip.id"
          :trip="trip"
          :executor="trip.executor"
          @updateExecutor="updateExecutor"
          @updateCar="updateCar"
          @updateTrip="updateTrip"
          @sendOrder="sendOrder"
          @sendTMS="sendTMS"/>

          <div v-else-if="!trip.executor && !trip.random_executor" class="executor-none">
            <p>Нет исполнителя</p>
            <p v-if="trip.approval && isTripApprovalEnabled" class="approval-warn">Тариф на согласовании у руководителя. Исполнителя можно назначить, но перевод в «В пути» будет недоступен до согласования тарифа.</p>
            <button v-if="trip.executor_price" class="change-button" @click="showModal('executor')">Назначить исполнителя</button>
          </div>
        </div>

        <TripDowntimeStatuses
          v-if="useNewExecutorInfo && trip.id"
          :trip-id="trip.id"
        />
        
        <div class="executors-info">
          <CustomerTripInfo 
            v-if="trip.customer"
            :redact="trip.is_my"
            :customer="trip.customer"
            :customer_id="trip.customer_id"
            @updateItem="updateTrip"
            @updateTrip="updateTrip"
            @updateCustomer="changeCustomer"
            />
          <div v-else class="executor-none">
            <p>Нет заказчика</p>
            <button 
            class="change-button mr-l-30" 
            v-show="trip.is_my"
            @click="showModal('customer')">Назначить заказчика</button>
          </div>
        </div>

        <TripInfo v-if="trip" class="" :trip="trip" />
        <TripHistory v-if="trip && trip.id" :trip-id="trip.id" :key="'history-' + trip.id" />
        <RoutePointInfo v-if="trip.route_point" class="" 
        :routes="trip.route_point" 
        @updateRouteInfo="updateRoute"
        :key="routeKey"
        />
        <LoadInfo 
        @fileStatus="screenUpload"
        @updateLoadTime="correctDateTimeLoad" 
        v-if="trip" :trip="trip"/>

        <comment-block 
        class="comment-block"
        @addComment="addComment"
        @updateComment="refresh('Comment')"
        :comments="comments" />

        <label class="executor-mode-toggle">
          <input type="checkbox" v-model="useNewExecutorInfo">
          <span>Новый режим карточки исполнителя</span>
        </label>
      </div>


    </div>
    <div v-else><h2>Нет Данных</h2></div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { computed,ref, onMounted, watch } from 'vue'
import TripInfo from '@/pages/trip/components/TripInfo.vue'
import TripInput from '@/pages/trip/components/TripInput.vue'
import TripManagerMenu from '@/pages/trip/components/TripManagerMenu.vue'
import RoutePointInfo from '@/pages/trip/components/RoutePointInfo.vue'
import ExecutorTripInfo from '@/pages/trip/components/ExecutorTripInfo.vue'
import ExecutorTripInfoLegacy from '@/pages/trip/components/ExecutorTripInfoLegacy.vue'
import TripDowntimeStatuses from '@/pages/trip/components/TripDowntimeStatuses.vue'
import CustomerTripInfo from '@/pages/trip/components/CustomerTripInfo.vue'
import ExecutorFormSearch from '@/pages/trip/components/ExecutorFormSearch'
import CustomerFormSearch from '@/pages/trip/components/CustomerFormSearch'
import LoadInfo from '@/pages/trip/components/LoadInfo'
import TripHistory from '@/pages/trip/components/TripHistory.vue'
import { createToaster } from '@meforma/vue-toaster'
import { checkKonturXml, downloadKonturXml } from '@/backend/konturApi'
import { downloadBlobResponse } from '@/backend/download'
import { humanizeApiError } from '@/backend/errorMessages'
import { konturWarningsConfirmation, normalizeKonturResult } from '@/pages/trip/helpers/konturResult.mjs'

export default {
  name: 'TripDetail',
  components:{
    TripInfo,
    TripInput,
    TripManagerMenu,
    RoutePointInfo,
    ExecutorTripInfo,
    ExecutorTripInfoLegacy,
    TripDowntimeStatuses,
    ExecutorFormSearch,
    CustomerFormSearch,
    CustomerTripInfo,
    LoadInfo,
    TripHistory
  },
  setup(){
    const EXECUTOR_INFO_MODE_KEY = 'executor_ui_v2'
    const TMS_WEB_URL = process.env.VUE_APP_TMS_URL || 'https://napitkivmeste.artlogic-sk.ru'
    const store = useStore()
    const route = useRoute()
    const inputKey = ref(0)
    const routeKey = ref(0)
    const tripStatus=computed(()=>store.state.apiStorage.options.trip_status)
    const dialogVisible = ref(false)
    const modalSwitcher = ref(false)
    const storedExecutorInfoMode = localStorage.getItem(EXECUTOR_INFO_MODE_KEY)
    const useNewExecutorInfo = ref(storedExecutorInfoMode === '1' || storedExecutorInfoMode === 'true')
    const trip_id = route.params.id
    const trip = computed(()=>store.state.cargos.tripPage.item)
    const canKonturExport = computed(() => store.getters.hasPermission('kontur.export'))
    const konturLoading = ref(false)
    const isTripApprovalEnabled = computed(()=>store.getters['isTripApprovalEnabled'])

    watch(useNewExecutorInfo, (value) => {
      localStorage.setItem(EXECUTOR_INFO_MODE_KEY, value ? '1' : '0')
    })

    onMounted(() => {
      store.dispatch('cargos/getOptions',{name:'payment_methods'})
      store.dispatch('cargos/getOptions',{name:'payment_term'})
      store.dispatch('cargos/getTrip',{trip_id})
      store.dispatch('cargos/getComment',{trip_id}) 
    })

    const forceRender = ()=>{
      inputKey.value += 1
    }

    const forceRoute = ()=>{
      routeKey.value += 1
    }

    const addComment = async (text) =>{
      await store.dispatch('cargos/addComment',{trip_id,form:{trip_id, text}})
    }

    const refresh = (name) =>{
      store.dispatch('cargos/get'+name,{trip_id})
    }

    const updateRoute = async(routes)=>{

      // Проходим по каждому маршруту и отправляем запрос
      const updatePromises = routes.map((route) => {
        // Вызываем action из store
        const link = '/'+trip_id+'/route-point/'+route.id
        return store.dispatch('cargos/updateRoutePoints', {link,route});
      });

      // Ждем выполнения всех запросов
      await Promise.all(updatePromises);
      forceRoute()
    }

    const updateTrip = async (form) =>{
      if(!form.id) form.id = trip_id
      dialogVisible.value = false
      await store.dispatch('cargos/updateTrip',{trip_id,form})
      // Перемонтируем форму только после ответа сервера — с тем, что реально сохранилось.
      forceRender()
    }

    const updateExecutor = async({form,model,onSaved}) =>{
      try {
        const response = await store.dispatch('executors/updateSecure',{form,model})
        if(!response) {
          onSaved?.(false)
          return
        }
        await store.commit('cargos/'+model+'Update',response)
        onSaved?.(true)
      } catch {
        onSaved?.(false)
      }
    }

    const updateCar = async(form) =>{
      const response = await store.dispatch('executors/updateCar',{form})
      if(response){
        await store.commit('cargos/carsUpdate',response)
      }
    }
    

    const screenUpload = (status)=>{
      trip.value.approval_factory_screenshot = status
    }

    const showModal = name =>{
      if(name === 'executor'){
        modalSwitcher.value = true
      }else{
        modalSwitcher.value = false
      }
      dialogVisible.value = true
    }

    const filteredStatus = (name) => {
      const status = tripStatus.value.filter((status) => status.title === 'Назначить исполнителя')
      if(status[0]){
        return{id:status[0].id,name:status[0].name}
      }
      return
    };

    const addCustomer = id =>{
      const form = {
        status:filteredStatus('Принять в работу'),
        customer_id:id
      }
      updateTrip(form)
    }

    const changeCustomer = (customer_id) =>{
      store.dispatch('cargos/changeCustomer',route.params.id+'/customer/change/'+customer_id)
    }

    const addExecutor =(executor_id)=>{
      store.dispatch('cargos/updateStatus',{link:route.params.id+'/executor/add',form:{executor_id}})
      dialogVisible.value = false
    }

    const correctDateTimeLoad = val =>{
      store.dispatch('cargos/updateTrip',{trip_id,form:{id:trip_id,final_load_datetime:val.date+" "+val.time}})
    }

    const sendTMS = async payload =>{
      const type = typeof payload === 'string' ? payload : payload?.type
      try {
        const result = await store.dispatch('cargos/getTmsItem',{
          trip_id,
          type,
          sendAsOwn: Boolean(payload?.sendAsOwn),
        })
        payload?.resolve?.(result)
        return result
      } catch (error) {
        payload?.reject?.(error)
        if (typeof payload === 'string') throw error
        return undefined
      }
    }

    const sendOrder = async (handlers = {}) => {
      try {
        await store.dispatch('cargos/sendOrder', trip_id)
        handlers.resolve?.()
      } catch (e) {
        const detail = e?.message || 'Не удалось сформировать бланк заявки'
        const { createToaster } = await import('@meforma/vue-toaster')
        createToaster().error(typeof detail === 'string' ? detail : 'Не удалось сформировать бланк заявки')
        handlers.reject?.(e)
      }
    }

    const downloadKontur = async () => {
      if (!trip.value?.id || konturLoading.value) return
      konturLoading.value = true
      const toaster = createToaster()
      try {
        const result = normalizeKonturResult(await checkKonturXml(trip.value.id))
        if (result.errors.length) {
          toaster.error(`Kontur: ${result.errors.join('; ')}`)
          return
        }
        if (result.warnings.length && !window.confirm(konturWarningsConfirmation(result.warnings))) return
        const response = await downloadKonturXml(trip.value.id)
        await downloadBlobResponse(response, result.filename || `kontur_${trip.value.trip_id || trip.value.id}.xml`)
        toaster.success('XML Kontur скачан')
      } catch (error) {
        toaster.error(humanizeApiError(error))
      } finally {
        konturLoading.value = false
      }
    }

    return {
      sendOrder,
      canKonturExport,
      downloadKontur,
      konturLoading,
      useNewExecutorInfo,
      routeKey,
      forceRoute,
      updateRoute,
      changeCustomer,
      forceRender,
      inputKey,
      updateCar,
      updateExecutor,
      refresh,
      screenUpload,
      correctDateTimeLoad,
      addComment,
      addCustomer,
      modalSwitcher,
      showModal,
      dialogVisible,
      addExecutor,
      sendTMS,
      updateTrip,
      comments:computed(()=>store.state.cargos.tripPage.comments),
      trip,
      isTripApprovalEnabled,
      loading:computed(() => store.state.cargos.tripPage.loading),
      TMS_WEB_URL,
    }
  }
}
</script>

<style scoped>
.small{
  font-size: 14px;
}

.tms-link {
  color: #0b66c3;
  text-decoration: underline;
}

.icon{
  padding: 3px;
  width: 17px;
  height: 17px;
  margin-left: 10px;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
}

.bg-success{
  border-radius: 2px;
  padding: 2px;
  background-color: rgba(152,236,131,0.6);
}

.bg-denied{
  border-radius: 2px;
  padding: 2px;
  background-color: rgba(182,0,24,0.4);
}

.trailer{
  color: blue;
  border-radius: 5px;
  text-align: center;
  padding: 5px 0;
}

.cards{
  display: flex;
  flex-direction: column;
  padding: 15px;
}

.card-item{
  border-radius: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  padding: 15px;
}

.header-content{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.trip-number{
  text-align: center;
/*  margin-top: 25px;*/
}

.trip-manager{
  margin-left: 6px;
  color: #475467;
  font-weight: 600;
}

.change-button {
  margin-top: 2px;
  padding: 5px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 200px;
}

.executor-none{
  padding: 10px;
  border-radius: 10px;
  margin-top: 15px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.approval-warn{
  color: #C33245;
  font-size: 13px;
  max-width: 320px;
  text-align: center;
}

.executor-mode-toggle{
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
  font-size: 13px;
  color: #555;
}

.executor-mode-toggle input{
  margin: 0;
}

.mr-l-30{
  margin-left: 30px;
}

.comment-block{
  margin-top: 15px;
}

.nav-top{
  display: flex;
  align-items: center;
}

.kontur-button{
  margin-left: 10px;
  padding: 4px 8px;
  border: 1px solid #007bff;
  border-radius: 4px;
  background: #fff;
  color: #007bff;
  cursor: pointer;
}

.kontur-button:disabled{
  cursor: wait;
  opacity: .7;
}
</style>
